<template>
  <div class="stream-details">
    <div class="page-header">
      <Breadcrumb>
        <BreadcrumbItem :to="`/nodes/${nodeID}/source`">{{ this.$t('streams.source') }}</BreadcrumbItem>
        <BreadcrumbItem>{{ accessTitle }}</BreadcrumbItem>
      </Breadcrumb>
      <div v-if="accessType === 'create'" class="mode-swtich">
        <label for="">{{ isTextMode ? $t('rules.textMode') : $t('rules.visualizationMode') }}</label>
        <i-switch v-model="isTextMode" @change="handleClearValidate"></i-switch>
      </div>
    </div>
    <Card shadow class="detail">
      <!-- view -->
      <div v-if="isView" class="view-form">
        <Spin v-if="viewLoading" fix> </Spin>
        <Row>
          <i-col span="16">
            <div class="view-item">
              <label class="view-item--label">{{ $t('streams.streamName') }}: </label>
              <span>{{ viewForm.name }}</span>
            </div>
            <div class="view-item">
              <label class="view-item--label">{{ $t('streams.streamFields') }}: </label>
              <FieldsTable
                class="view-item--table"
                v-model="viewForm.streamFields"
                :isDetail="accessType === 'view'"
                disabled
              ></FieldsTable>
            </div>
            <template v-if="viewForm.options">
              <div v-for="(key, index) in Object.keys(viewForm.options)" :key="index" class="view-item">
                <label class="view-item--label">{{ key }}: </label>
                <span>{{ viewForm.options[key] }}</span>
              </div>
            </template>
          </i-col>
        </Row>
      </div>
      <!-- create |edit  -->
      <Form v-else ref="record" :model="createForm" :rules="rules">
        <Row>
          <!--1. Text Mode  -->
          <i-col v-if="isTextMode" span="16">
            <FormItem label="SQL" prop="sql">
              <div class="monaco-container sql">
                <Monaco
                  id="sql-data"
                  ref="sqlData"
                  v-model="createForm.sql"
                  lang="sql"
                  backgroud="#282a36"
                  :provider="dataTypeProvider"
                >
                </Monaco>
              </div>
            </FormItem>
          </i-col>

          <!-- 2. Visualization Mode -->
          <template v-else>
            <!-- name -->
            <i-col span="16">
              <FormItem :label="$t('streams.streamName')" prop="name">
                <i-input v-model="createForm.name" size="large" :disabled="accessType === 'edit'"></i-input>
              </FormItem>
            </i-col>
            <!-- is Schema Stream -->
            <i-col span="16">
              <i-checkbox v-model="isSchemaStream" class="single-checkbox">{{ $t('streams.isSchemaType') }}</i-checkbox>
            </i-col>

            <!-- streamFields -->
            <i-col v-if="isSchemaStream" span="16">
              <FormItem :label="$t('streams.streamFields')" prop="streamFields">
                <Tooltip
                  class="fields-table--tip"
                  :max-width="350"
                  transfer
                  :content="$t('streams.schemaTip')"
                  placement="right"
                >
                  <Icon type="md-help-circle"> </Icon>
                </Tooltip>
                <FieldsTable
                  v-model="createForm.streamFields"
                  :isDetail="accessType === 'edit'"
                  :streamFormat="createForm.format"
                ></FieldsTable>
              </FormItem>
            </i-col>

            <!-- streamType -->
            <i-col span="16">
              <FormItem :label="$t('streams.streamType')" prop="streamType">
                <!-- documentation -->
                <a v-if="sourceInfo.helpUrl" :href="i18nLabel(sourceInfo.helpUrl)" target="_blank" rel="noopener">
                  <Icon type="md-document" />
                  {{ $t('common.documentation') }}
                </a>
                <!-- <Button
                  v-if="!isView"
                  class="top-create--btn action-add-btn"
                  icon="ios-create-outline"
                  type="primary"
                  ghost
                  @click="handleConfigSources"
                >
                  {{ $t('streams.sourceConfig') }}
                </Button> -->
                <ConfKeyTypesSeletor
                  v-model="createForm.streamType"
                  :category="category"
                  @onChange="changeStreamType"
                  @onSelected="handleSourceSelected"
                />
              </FormItem>
            </i-col>

            <!-- dataSource -->
            <!-- if `dataSource` isnot {}, show dataSource -->
            <i-col v-if="isShowDataSource" span="16">
              <FormItem prop="dataSource">
                <template slot="label">
                  <span>{{ i18nLabel(dataSourceInfo.label) || $t('streams.dataSource') }}</span>
                </template>
                <Tooltip
                  v-if="dataSourceInfo.hint"
                  max-width="250px"
                  class="field-help"
                  transfer
                  placement="top"
                  :content="i18nLabel(dataSourceInfo.hint)"
                >
                  <Icon v-if="dataSourceInfo.hint" type="md-help-circle" />
                </Tooltip>
                <i-input v-model="createForm.dataSource" size="large"></i-input>
              </FormItem>
            </i-col>

            <!-- confKey -->
            <i-col span="16">
              <FormItem :label="$t('configuration.confKey')" prop="confKey">
                <Button
                  v-if="createForm.confKey"
                  icon="ios-create-outline"
                  type="primary"
                  ghost
                  class="top-create--btn action-add-btn"
                  @click="showConfKeyModel('edit')"
                >
                  {{ $t('configuration.editConfKey') }}
                </Button>
                <Button
                  v-if="createForm.streamType"
                  icon="ios-add"
                  type="primary"
                  ghost
                  class="top-create--btn action-add-btn"
                  @click="showConfKeyModel()"
                >
                  {{ $t('configuration.addConfKey') }}
                </Button>
                <ConfKeysSelector
                  ref="confKeysSelectorRef"
                  v-model="createForm.confKey"
                  :category="category"
                  :type="createForm.streamType"
                  @on-open-change="handleConfKeyOpen"
                />
              </FormItem>
            </i-col>

            <!-- format -->
            <i-col span="16">
              <FormItem :label="$t('streams.format')" prop="format">
                <i-input
                  v-if="createForm.streamType.toLowerCase() === 'can'"
                  v-model="createForm.format"
                  size="large"
                  disabled
                />
                <FormatsSelector v-else v-model="createForm.format" :nodeID="nodeID" @onChange="changeFormat" />
              </FormItem>
            </i-col>

            <!-- format: protobuf | custom -->
            <div v-if="createForm.format === 'protobuf' || createForm.format === 'custom'" class="format-content">
              <i-col span="16">
                <FormItem :label="$t('streams.schemaName')" prop="format">
                  <SchemasSelector
                    v-model="createForm.schemaName"
                    :type="createForm.format"
                    @onChange="changeSchemaName"
                    @clear="changeSchemaName"
                  />
                </FormItem>
              </i-col>
              <i-col span="16">
                <FormItem :label="$t('streams.schemaMessage')" prop="format">
                  <i-input v-model="createForm.schemaMessage" size="large"></i-input>
                </FormItem>
              </i-col>
            </div>
            <!-- format: delimited -->
            <i-col span="16" v-if="createForm.format === 'delimited'">
              <FormItem :label="$t('streams.delimited')" prop="delimited">
                <i-input v-model="createForm.delimited" size="large"></i-input>
              </FormItem>
            </i-col>

            <!--  timestamp -->
            <i-col span="16">
              <FormItem :label="$t('streams.timestamp')" prop="timestamp">
                <Tooltip
                  class="field-help"
                  :max-width="250"
                  transfer
                  :content="$t('streams.timestampDesc')"
                  placement="right"
                >
                  <Icon type="md-help-circle"> </Icon>
                </Tooltip>
                <i-input v-model="createForm.timestamp" size="large"></i-input>
              </FormItem>
            </i-col>
            <!--  timestamp foramt -->
            <i-col span="16">
              <FormItem :label="$t('streams.timestampFormat')" prop="timestampFormat">
                <i-input v-model="createForm.timestampFormat" placeholder="YYYY-MM-dd T HH:mm:ss" size="large" />
              </FormItem>
            </i-col>

            <!-- shared -->
            <i-col span="16">
              <FormItem :label="$t('streams.shared')" prop="format">
                <Radio-group v-model="createForm.shared">
                  <Radio label="true"></Radio>
                  <Radio label="false"></Radio>
                </Radio-group>
              </FormItem>
            </i-col>
          </template>
          <i-col span="16" class="oper-col">
            <FormItem>
              <Button v-if="!isView" type="primary" @click="save">{{ $t('common.submit') }}</Button>
              <Button :style="!isView ? 'margin-left: 8px' : ''" type="text" @click="goBack">
                {{ $t('common.cancel') }}
              </Button>
            </FormItem>
          </i-col>
        </Row>
      </Form>
    </Card>

    <!-- conf key config -->
    <ConfKeyPeopertiesModal
      v-if="createForm.streamType"
      ref="confKeyPropertiesRef"
      :modalVisible.sync="confKeyPropertiesVisible"
      :title="confKeyModalTitle"
      :category="category"
      :type="createForm.streamType"
      :confKeyName="createForm.confKey"
      :isEdit="isEditConfKey"
      @submit="submitedConfKey"
    />
  </div>
</template>

<script>
import nodeID from '@/mixins/nodeID'
import schema from '@/mixins/schema'
import currentLang from '@/mixins/currentLang'
import Monaco from '@/components/Monaco'
import { createStream, viewStream, updateStream } from '@/api/stream'
import { getMetadataByCategory } from '@/api/metadata'
import FieldsTable from './components/FieldsTable.vue'
import dataTypeProviderData from '../../utils/dataTypeProviderData'
import sqlKeyWords from '../../utils/sqlKeyWords'
import parseStreamSql, { parseWithStatement } from '../../utils/parseStreamSql'
import ConfKeyPeopertiesModal from '@/views/configuration/resource/components/ConfKeyPropertiesModal.vue'
import ConfKeyTypesSeletor from '@/components/ConfKeyTypesSeletor.vue'
import ConfKeysSelector from '@/components/ConfKeysSelector.vue'
import FormatsSelector from '@/components/FormatsSelector.vue'
import SchemasSelector from '@/components/SchemasSelector.vue'
import { RESOURCE_TYPE } from '@/utils/constants'

export default {
  name: 'StreamDetails',

  components: {
    Monaco,
    FieldsTable,
    ConfKeyPeopertiesModal,
    ConfKeyTypesSeletor,
    ConfKeysSelector,
    FormatsSelector,
    SchemasSelector,
  },

  mixins: [nodeID, currentLang, schema],

  data() {
    return {
      category: RESOURCE_TYPE.sources,
      accessType: this.$route.query.oper,
      isTextMode: false,
      isSchemaStream: false,
      viewLoading: false,
      viewForm: {},
      sourceInfo: {},
      dataSourceInfo: {
        default: '',
        hint: null,
        label: null,
      },
      createForm: {
        name: '',
        streamType: '',
        confKey: '',
        dataSource: '',
        format: '',
        shared: 'false',
        schemaName: '',
        schemaMessage: '',
        delimited: '',
        sql: '',
        timestamp: '',
        timestampFormat: '',
      },
      rules: {
        name: [
          { required: true, message: this.$t('common.fillContent') },
          { validator: this.validateStreamName, trigger: 'blur' },
        ],
        sql: [{ required: true, message: this.$t('common.fillContent') }],
        streamFields: [{ required: true, message: this.$t('common.fillContent') }],
      },
      confKeyPropertiesVisible: false,
      isEditConfKey: false,
    }
  },

  computed: {
    isView() {
      const { oper } = this.$route.query
      return oper === 'view'
    },
    accessTitle() {
      const { oper } = this.$route.query
      const operDict = {
        view: this.$t('common.view'),
        create: this.$t('common.create'),
        edit: this.$t('common.edit'),
      }
      return operDict[oper]
    },
    dataTypeProvider() {
      return [...sqlKeyWords.sqlKeyWords, ...dataTypeProviderData]
    },
    confKeyModalTitle() {
      return !this.isEditConfKey
        ? this.$t('configuration.addSourceConfKey')
        : this.$t('configuration.editSourceConfKey')
    },
    // if `datasource` key exists, but the value is empty, i.e. dataSource: {}, just hide the `dataSource`.
    isShowDataSource() {
      return !this.dataSourceInfo || Object.keys(this.dataSourceInfo).length
    },
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const fromSource = from.name === 'sources'
      const streamForm = sessionStorage.getItem('streamForm')
      const isSchemaStream = sessionStorage.getItem('isSchemaStream')
      if (fromSource && streamForm && isSchemaStream) {
        vm.createForm = JSON.parse(streamForm)
        vm.isSchemaStream = isSchemaStream === 'true'
      } else if (vm.accessType !== 'create') {
        vm.loadDetail()
      }
      setTimeout(() => {
        sessionStorage.removeItem('streamForm')
        sessionStorage.removeItem('isSchemaStream')
      }, 2000)
    })
  },

  created() {
    this.init()
  },

  methods: {
    setDefaultForm() {
      this.createForm = {
        name: '',
        streamType: 'mqtt',
        confKey: '',
        dataSource: '',
        format: 'json',
        shared: 'false',
        schemaName: '',
        schemaMessage: '',
        delimited: '',
        sql: '',
        timestamp: '',
        timestampFormat: '',
      }
    },

    init() {
      if (this.accessType === 'create') {
        this.setDefaultForm()
        this.changeStreamType(this.createForm.streamType)
      }
    },
    validateStreamName(rule, value, callback) {
      if (!value) {
        return callback(new Error(this.$t('common.fillContent')))
      }
      if (/\s/.test(value)) {
        return callback(new Error(this.$t('streams.streamNameSpace')))
      }
      callback()
      return true
    },

    parseStremFields({ StreamFields }) {
      const parseData = (data) => {
        const streamFields = {}
        data.forEach((field) => {
          if (typeof field.FieldType === 'string') {
            streamFields[field.Name] = field.FieldType
          } else if (field.FieldType.Type === 'struct') {
            streamFields[field.Name] = parseData(field.FieldType.Fields)
          } else if (field.FieldType.Type === 'array') {
            streamFields[field.Name] = `${field.FieldType.Type}(${field.FieldType.ElementType})`
          }
        })
        return streamFields
      }
      return parseData(StreamFields)
    },

    loadDetail() {
      const { streamName } = this.$route.params
      this.viewModalVisible = true
      this.viewLoading = true
      viewStream(this.nodeID, streamName)
        .then((res) => {
          const { data } = res
          if (this.accessType === 'view') {
            let streamFields = {}
            if (data.StreamFields) {
              streamFields = this.parseStremFields(data)
            }
            this.viewForm = {
              name: data.Name,
              options: data.Options,
              streamFields,
            }
          } else {
            const { Name, Options, StreamFields } = data
            const {
              datasource: dataSource,
              confKey,
              format,
              type,
              shared,
              strictValidation,
              schemaid,
              schemaName,
              schemaMessage,
              delimiter,
              timestamp,
              timestampFormat,
            } = Options

            const schemaData = {}
            if (schemaid) {
              const schemaInfo = schemaid.split('.')
              schemaData.schemaName = schemaInfo[0]
              schemaData.schemaMessage = schemaInfo[1]
            }

            this.createForm = {
              name: Name,
              dataSource,
              confKey,
              format,
              streamType: type,
              shared: shared ? String(shared) : 'false',
              strictValidation,
              schemaName: schemaName || schemaData.schemaName || '',
              schemaMessage: schemaMessage || schemaData.schemaMessage || '',
              delimited: delimiter || '',
              timestamp,
              timestampFormat,
            }

            if (!StreamFields) {
              this.isSchemaStream = false
            } else {
              this.isSchemaStream = true
              this.createForm.streamFields = this.parseStremFields(data)
            }
          }
          this.viewLoading = false
        })
        .then(() => {
          // get `dataSource` label & value
          this.changeStreamType(this.createForm.streamType, this.createForm.dataSource)
        })
        .catch(() => {
          this.viewLoading = false
        })
    },

    handleConfigSources() {
      sessionStorage.setItem('streamForm', JSON.stringify(this.createForm))
      sessionStorage.setItem('isSchemaStream', this.isSchemaStream)
      this.$router.push({
        path: `/nodes/${this.nodeID}/configuration`,
        query: {
          oper: this.accessType,
        },
      })
    },

    setDataSourceDefaultValue() {
      this.createForm.dataSource = ''
      this.dataSourceInfo = {
        default: '',
        hint: null,
        label: null,
      }
    },
    // change Source：set the type `dataSource` label && default value
    async changeStreamType(streamType, dataSourceVal) {
      if (!streamType) {
        this.setDataSourceDefaultValue()
        return Promise.resolve()
      }

      try {
        const params = {
          nodeID: this.nodeID,
          name: streamType,
        }
        const res = await getMetadataByCategory(this.category, params)
        const { dataSource } = res.data

        // set `dataSource` label
        this.dataSourceInfo = dataSource || {
          default: '',
          hint: null,
          label: null,
        }

        // set `dataSource` value
        this.createForm.dataSource = dataSourceVal || dataSource?.default || ''
        if (streamType.toLowerCase() === 'can') {
          this.createForm.format = 'can'
        }

        return Promise.resolve(res)
      } catch (error) {
        this.setDataSourceDefaultValue()
        return Promise.reject(error)
      }
    },

    // change type to get stream type document link
    handleSourceSelected(data) {
      this.sourceInfo = data ? data.about : {}
    },

    handleConfKeyOpen(visible) {
      if (!this.createForm.streamType && visible) {
        this.$Message.warning(this.$t('streams.typeFirst'))
      }
    },

    // show conf Key properties modal: add | edit
    showConfKeyModel(oper) {
      this.isEditConfKey = oper === 'edit'
      this.confKeyPropertiesVisible = true
    },
    submitedConfKey(data) {
      const { name } = data
      // reload conf keys after add a confKey && set `confKey` value to `name`
      this.$refs.confKeysSelectorRef.reload(name)
    },

    changeFormat(val) {
      this.createForm.schemaName = ''
      this.changeSchemaName()
      this.createForm.delimited = val === 'delimited' ? ',' : ''
    },

    changeSchemaName() {
      this.createForm.schemaMessage = ''
    },

    save() {
      this.$refs.record.validate((valid) => {
        if (!valid) {
          return
        }
        const data = {
          sql: '',
        }
        if (!this.isTextMode) {
          const {
            name,
            streamFields,
            confKey,
            format,
            dataSource,
            streamType,
            shared,
            schemaName,
            schemaMessage,
            delimited,
            timestamp,
            timestampFormat,
          } = this.createForm
          const $streamName = `CREATE STREAM ${name}`
          const $streamFields = streamFields || '()'
          const $streamWith = parseWithStatement({
            DATASOURCE: dataSource,
            FORMAT: format,
            CONF_KEY: confKey,
            TYPE: streamType,
            SHARED: shared,
            ...(schemaName && schemaMessage && { SCHEMAID: `${schemaName}.${schemaMessage}` }),
            ...(format === 'delimited' && { DELIMITER: delimited }),
            ...(timestamp && { TIMESTAMP: timestamp }),
            ...(timestampFormat && { TIMESTAMP_FORMAT: timestampFormat }),
          })
          data.sql = parseStreamSql`
              ${$streamName}
              ${$streamFields}
              ${$streamWith}
          `
        } else {
          data.sql = this.createForm.sql
        }
        if (this.accessType === 'create') {
          createStream(this.nodeID, data)
            .then((res) => {
              if (res.status === 201 && res.statusText === 'Created') {
                this.$Message.success(res.data)
              } else {
                this.$Message.success(this.$t('common.addSuccess'))
              }
              this.goBack()
            })
            .catch(() => {})
        } else {
          updateStream(this.nodeID, this.createForm.name, data)
            .then(() => {
              this.$Message.success(this.$t('common.editSuccess'))
              this.goBack()
            })
            .catch(() => {})
        }
      })
    },
    handleClearValidate() {
      setTimeout(() => {
        this.$refs.record.resetFields()
      }, 1000)
    },
    goBack() {
      this.$router.push({
        name: 'source',
        params: {
          id: this.nodeID,
        },
      })
    },
  },
}
</script>

<style lang="scss">
.stream-details {
  .ivu-card {
    .monaco-container.sql {
      margin-top: 43px;
    }
    .ivu-card-body {
      padding: 20px;
    }
    .ivu-checkbox-wrapper {
      margin-bottom: 8px;
    }
    .monaco-container.fields {
      height: 300px;
      margin-top: 8px;
    }
    .fields-table--tip {
      position: absolute;
    }
  }
  .action-add-btn {
    margin-left: 10px;
  }
  .field-help {
    position: relative;
    top: 2px;
    left: -2px;
  }
  .format-content {
    width: 100%;
  }
}
</style>
